import { useEffect } from 'react'

// import Rating from '../Rating'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  add_to_card,
  add_to_wishlist,
  get_card_products,
  get_wishlist,
} from '../../store/reducers/cardReducer'

import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { Swiper, SwiperSlide } from 'swiper/react'
import { backend_url_img } from '../../api/server'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { FaEye, FaHeart, FaRegHeart } from 'react-icons/fa'
import { getCurrentTime } from '../../utils/timeConvertor'

const NewArrivalProducts = ({ products }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  // const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const { userInfo } = useSelector((state) => state.auth)
  const { wishlist } = useSelector((state) => state.card)

  const [selectedPacks, setSelectedPacks] = useState({})

  useEffect(() => {
    if (products?.length) {
      const initialSelection = {}
      products.forEach((p) => {
        if (p.packs?.length > 0) {
          initialSelection[p._id] = p.packs[0] // select the first pack
        }
      })
      setSelectedPacks(initialSelection)
      dispatch(get_wishlist(userInfo?.id))
    }
  }, [products, dispatch])

  const isFavorite = (productId) =>
    wishlist?.some((item) => item.productId._id === productId)

  const handleAddToCart = (product, selectedPack) => {
    const createdAt = getCurrentTime()

     if (!userInfo) {
      navigate('/login')
      return
    }
    if (!selectedPack) return

    const payload = {
      userId: userInfo.id,
      productId: product._id,
      quantity: 1,
      packs: [
        {
          pack: selectedPack.pack,
          price: selectedPack.price,
          selected: true,
          properties: selectedPack.properties || [],
        },
      ],
      createdAt: createdAt,
    }
dispatch(add_to_card(payload))
    
  }

  const add_wishlist = (product) => {
    const createdAt = getCurrentTime()
    if (!userInfo) {
      navigate('/login')
      return
    }

    const selectedPack = selectedPacks[product._id]

    const info = {
      userId: userInfo.id,
      productId: product._id,
      quantity: 1,
      packs: [selectedPack],
      createdAt: createdAt,
    }
dispatch(add_to_wishlist(info))
    
  }

  const getProductName = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arName
      case 'kr':
        return product?.kuName
      default:
        return product?.enName
    }
  }

  return (
    <div>
      {products && products.length > 0 ? (
        <section className="bg-[#FBFBFB] py-10">
          <div className="w-[68%] md:w-[80%] sm:w-[95%] lg:w-[90%] h-full mx-auto">
            <div className="w-full flex justify-center items-center border-b-[1px]">
              <h2 className="text-xl font-semibold p-2 rounded-tl-lg rounded-tr-lg  text-slate-600 ">
                {t('products.new_arrivals')}{' '}
              </h2>
            </div>
            <div className="py-3">
              <Swiper
                slidesPerView="auto"
                breakpoints={{
                  1280: {
                    slidesPerView: 5,
                    spaceBetween: 12,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                  },
                }}
                spaceBetween={12}
                loop={true}
                autoplay={{
                  delay: 3000, //
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                  el: '.custom_bullet',
                }}
                modules={[Pagination, Autoplay]} // Add Autoplay module here
                className="mySwiper"
              >
                {products?.map((p, i) => (
                  <SwiperSlide key={i}>
                    <div className="block p-1">
                      <div className="relative group flex hover:shadow-md  flex-col pb-2 w-full gap-1 bg-white rounded-md border border-grey-200 h-[450px] sm:h-[400px]">
                        {/* Square Image Container */}
                        <div className="overflow-hidden w-full aspect-square">
                          <div className="absolute top-2 right-2 bg-white text-red-500 border border-red-500 text-xs font-bold w-6 h-6 rounded-full flex justify-center items-center z-10">
                            18+
                          </div>

                          {/* {p.discount !== 0 && (
                            <div className="absolute top-2 left-2 bg-red-500 text-white text-sm font-bold rounded-full w-10 h-10 flex items-center justify-center z-10">
                              -{p.discount}%
                            </div>
                          )} */}
                          <Link to={`/product/details/${p.slug}`}>
                            <img
                              className="w-full h-full object-cover cursor-pointer "
                              src={`${backend_url_img}/${p.images[0]}`}
                              alt={getProductName(p)}
                            />
                          </Link>
                        </div>

                        {/* Product Details */}
                        <div className="w-full bg-gray-20   p-2">
                          <div className="flex w-full justify-center items-center flex-col px-0 gap-2 ">
                            {/* Product Name */}
                            <div className="w-full border-b-[1px]">
                              <Link to={`/product/details/${p.slug}`}>
                                <h2 className="text-sm font-semibold py-3 overflow-hidden text-ellipsis whitespace-nowrap">
                                  {getProductName(p)}
                                </h2>
                              </Link>
                            </div>
                            {/* <div className="flex justify-start items-center w-full border-b-[2px] gap-3">

                            <h2 className="text-sm  py-2">
                              {t('products.product_code')} :
                            </h2>
                            <h2 className="text-sm font-semibold text-primary">
                              {p.productCode}
                            </h2>
     
                          </div> */}
                          </div>
                          <div className="flex w-full flex-col gap-3">
                            {/* Pack Buttons */}
                            <div className="flex w-full items-center flex-col mt-3">
                              <div className="flex items-center gap-2">
                                {p.packs?.map((pack, index) => {
                                  const isSelected =
                                    selectedPacks[p._id]?.pack?.code ===
                                    pack.pack.code

                                  return (
                                    <button
                                      key={index}
                                      onClick={() =>
                                        setSelectedPacks((prev) => ({
                                          ...prev,
                                          [p._id]: pack,
                                        }))
                                      }
                                      className={`w-12 h-14 flex flex-col items-center justify-center border rounded-md text-sm font-semibold 
          ${
            isSelected
              ? 'bg-darkRed text-white'
              : 'bg-gray-100 text-bg-primary border-gray-200'
          }
        `}
                                    >
                                      <span className="text-center">
                                        {pack.pack.code}
                                      </span>
                                      <span className="text-center">
                                        {getProductName(pack.pack)}
                                      </span>
                                    </button>
                                  )
                                })}
                              </div>
                            </div>

                            <div className="flex justify-between items-center mt-2 text-sm font-semibold">
                              {/* Left side: discounted price */}
                              <span>
                                {selectedPacks[p._id]
                                  ? new Intl.NumberFormat('en-US').format(
                                      selectedPacks[p._id].price -
                                        Math.floor(
                                          (selectedPacks[p._id].price *
                                            p.discount) /
                                            100
                                        )
                                    )
                                  : ''}{' '}
                                {t('products.currency')}
                                {'/'}
                                {getProductName(p.packs?.[0].pack)}
                              </span>

                              <span>
                                {selectedPacks[p._id]
                                  ? new Intl.NumberFormat('en-US').format(
                                      selectedPacks[p._id].price *
                                        selectedPacks[p._id].pack.code
                                    )
                                  : ''}
                              </span>
                            </div>

                            <div className="flex w-full items-center flex-col mt-3 ">
                              <button
                                disabled={p.stock <= 0}
                                className={`px-3 py-2 rounded-full transition-colors duration-300 z-10
                                ${
                                      p.stock > 0
                                      ? 'bg-primary border border-gray-300 text-white hover:bg-darkRed hover:text-white'
                                      : 'bg-gray-400 border border-gray-300 text-gray-200 cursor-not-allowed'
                                  }`}
                                onClick={() =>
                                  handleAddToCart(p, selectedPacks[p._id])
                                }
                              >
                                {t('products.add_to_card')}
                              </button>
                              <ul
                                className="absolute bottom-[-50px] left-0 sm:hidden w-full flex justify-between items-center px-2 gap-2
                                opacity-0 group-hover:opacity-100 group-hover:bottom-4
                                transition-all duration-500"
                              >
                                <li
                                  onClick={() => add_wishlist(p)}
                                  className={`w-[38px] h-[38px] cursor-pointer flex justify-center items-center border border-slate-300 rounded-full transition-all
      ${
        isFavorite(p._id)
          ? 'bg-red-100 text-darkRed'
          : 'bg-[#FBFBFB] hover:bg-darkRed hover:text-white'
      }
    `}
                                >
                                  {isFavorite(p._id) ? (
                                    <FaHeart />
                                  ) : (
                                    <FaRegHeart />
                                  )}
                                </li>

                                <Link
                                  to={`/product/details/${p.slug}`}
                                  className="w-[38px] h-[38px] cursor-pointer flex justify-center items-center border bg-[#FBFBFB] rounded-full hover:bg-darkRed hover:text-white transition-all"
                                >
                                  <FaEye />
                                </Link>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* <div className="w-full flex justify-center items-center py-4">
              <div className="custom_bullet justify-center gap-3 !w-auto"></div>
            </div> */}
          </div>
        </section>
      ) : null}
    </div>
  )
}

export default NewArrivalProducts
